import { type AtomEffect, atom, selector } from 'recoil';
import { getCookie, setCookie } from '../../services/utils/cookieUtil';

const shouldCoverCriticalIllnessEffect: AtomEffect<boolean> = ({ onSet }) => {
    onSet((shouldCover) => {
        setCookie('shouldCoverCriticalIllness', shouldCover.toString());
    });
};

const shouldCoverCriticalIllnessSelector = selector<boolean>({
    key: 'shouldCoverCriticalIllnessSelector',
    get: () => {
        return getCookie('shouldCoverCriticalIllness') === 'true';
    }
});

export const shouldCoverCriticalIllnessAtom = atom<boolean>({
    key: 'shouldCoverCriticalIllness',
    default: shouldCoverCriticalIllnessSelector,
    effects: [shouldCoverCriticalIllnessEffect]
});
